var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "74D7544C-2F3F-4E49-A63A-12665C63339F") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "home",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.64
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1264.000000, -946.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    id: "footer"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 810.000000)",
    id: "chevron-up"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1288,136 C1301.25483,136 1312,146.745166 1312,160 C1312,173.254834 1301.25483,184 1288,184 C1274.74517,184 1264,173.254834 1264,160 C1264,146.745166 1274.74517,136 1288,136 Z M1288,138 C1275.84974,138 1266,147.849736 1266,160 C1266,172.150264 1275.84974,182 1288,182 C1300.15026,182 1310,172.150264 1310,160 C1310,147.849736 1300.15026,138 1288,138 Z M1297.29289,155.292893 L1298.70711,156.707107 L1288,167.414214 L1277.29289,156.707107 L1278.70711,155.292893 L1288,164.585 L1297.29289,155.292893 Z",
    transform: "translate(1288.000000, 160.000000) scale(1, -1) translate(-1288.000000, -160.000000) "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow-up.92a1be01.svg";
export { ForwardRef as ReactComponent };